// Browser ad-pixel helpers for Google Ads gtag and Meta Pixel.
// Gated on Cookiebot marketing consent and on the corresponding public env var
// being set, so missing config is a silent no-op rather than a runtime error.
//
// NOTE: only "Schedule" (meeting booked) fires from the browser. The "Lead"
// event is reported SERVER-SIDE ONLY now (Meta CAPI + Google Ads upload in
// backend/forms/onWritten.ts), fired the moment a lead finishes step 1 and a
// CRM contact is created. The browser Lead pixel used to fire on every submit —
// including junk we filter before HubSpot — which inflated Meta/Google lead
// counts above the first-party CRM count; reporting server-side keeps them 1:1.

declare global {
  interface Window {
    dataLayer?: unknown[];
    // gtag's signature is intentionally permissive — we use it for both
    // `gtag('config', id)` and `gtag('event', name, params)`.
    gtag?: (...args: unknown[]) => void;
    fbq?: (...args: unknown[]) => void;
    _fbq?: unknown;
  }
}

import { COOKIEBOT_ENABLED } from "./cookiebot";

export const GOOGLE_ADS_ID = process.env.NEXT_PUBLIC_GOOGLE_ADS_ID;
export const GOOGLE_ADS_SCHEDULE_LABEL =
  process.env.NEXT_PUBLIC_GOOGLE_ADS_SCHEDULE_LABEL;
export const META_PIXEL_ID = process.env.NEXT_PUBLIC_META_PIXEL_ID;

export function hasMarketingConsent(): boolean {
  if (typeof window === "undefined") return false;
  if (!COOKIEBOT_ENABLED) return true;
  return Boolean(window.Cookiebot?.consent?.marketing);
}

export function firePixelSchedule(eventId: string): void {
  if (typeof window === "undefined") return;
  if (!hasMarketingConsent()) return;

  if (META_PIXEL_ID && typeof window.fbq === "function") {
    window.fbq("track", "Schedule", {}, { eventID: eventId });
  }

  if (
    GOOGLE_ADS_ID &&
    GOOGLE_ADS_SCHEDULE_LABEL &&
    typeof window.gtag === "function"
  ) {
    window.gtag("event", "conversion", {
      send_to: `${GOOGLE_ADS_ID}/${GOOGLE_ADS_SCHEDULE_LABEL}`,
      transaction_id: eventId
    });
  }
}
